import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3;
import styled from '@emotion/styled';
import { layout } from '../styles';
export var StyledSelectCustomField = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\talign-items: center;\n\topacity: ", ";\n"])), function (props) {
  return props.disabled ? 0.5 : 1;
});
export var StyledSelectCustomLabel = styled.label(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tmargin-right: ", ";\n"])), layout.smallSpace);
export var StyledSelectCustomNumberInput = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\tmargin-top: ", ";\n"])), layout.smallSpace);